import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdtellFooterComponent } from "./edtell-footer/edtell-footer.component";
import { EdtellFooterHelperDirective } from "./directives/edtell-footer-helper.directives";

@NgModule({
  declarations: [EdtellFooterComponent, EdtellFooterHelperDirective],
  imports: [CommonModule],
  exports: [EdtellFooterComponent, EdtellFooterHelperDirective],
})
export class EdtellFooterModule {}
